import localStorageCall from '@/services/Methods/localstorage.hook';
import * as Yup from 'yup';
import { cleanPhoneNumber } from './normalMethods';

export const loginIntialValue = { email: '', password: '' }
const REFFERAL_VALUES = localStorageCall().getItem('refferal_link');  /*** get Refferal value from cookiee ***/
export const InitialValues = {
    email: "", firstName: "", lastName: "", phone: "", city: "", zipcode: "", address: "",
    address_2: "", webAlias: "", company_name: "", password: "", confirm_password: "", shirtsize: "",
    refferal: REFFERAL_VALUES?.webalies ? REFFERAL_VALUES?.webalies : "",
    termscondition: false,
    promotions: false,
    policyProcedures: false,
};

export function _formDefaultFormat(userData, formData, countryState) {
    return ({
        firstName: formData?.shipping_urname || userData?.firstName,
        lastName: formData?.shipping_lastname || userData?.lastName,
        email: formData?.shipping_email || userData?.emailAddress,
        phone: cleanPhoneNumber(formData?.shipping_phone) || cleanPhoneNumber(userData?.phoneNumbers?.cellPhone),
    })
}

export function _IBOformDefaultFormat(userData, formData, countryState) {
    return ({
        firstName: formData?.shipping_urname || userData?.firstName,
        lastName: formData?.shipping_lastname || userData?.lastName,
        email: formData?.shipping_email || userData?.emailAddress,
        phone: cleanPhoneNumber(formData?.shipping_phone) || cleanPhoneNumber(userData?.phoneNumbers?.cellPhone),
        address: formData?.shipping_street || userData?.shippingAddress?.address1,
        company_name: formData?.companyName || userData?.companyName,
        address_2: formData?.shipping_street2 || userData?.shippingAddress?.address2,
        city: formData?.shipping_city || userData?.shippingAddress?.city,
        zipcode: formData?.shipping_zipcode || userData?.shippingAddress?.postalCode,
        shipping_country: countryState?.shipping_country || userData?.countryCode || 'US',
        shipping_state: countryState?.shipping_state || userData?.shippingAddress?.regionProvState,
        // webAlias: formData?.webAlias || userData?.webAlias,
        // refferal: REFFERAL_VALUES?.webalies ? REFFERAL_VALUES?.webalies : ""
    })
}

export const BrandAffiliateInitialValues = {
    pathValue: "affiliate", selectedDay: "", selectedMonth: "", selectedYear: "", joinAs: "", zipcode: "", address: "", brandAgreement: false, privacyPolicy: false, electronicRecord: false, webAlias: "", businessName: "",
    businessCreationDate: null, businessAddress: "", businessAddress2: "", businessZip: "", businessCityState: "", refferal: REFFERAL_VALUES?.webalies ? REFFERAL_VALUES?.webalies : "",
};

export const BrandAmbassadorInitialValues = {
    pathValue: "ambassador", selectedDay: "", selectedMonth: "", selectedYear: "", joinAs: "", zipcode: "", address: "", brandAgreement: false, privacyPolicy: false, electronicRecord: false, webAlias: "", businessName: "",
    businessCreationDate: null, businessAddress: "", businessAddress2: "", businessZip: "", businessCityState: "", refferal: REFFERAL_VALUES?.webalies ? REFFERAL_VALUES?.webalies : "",
};

export const loginDefaultSchema = Yup.object().shape({
    email: Yup.string()
        .email('Please provide a valid email address.')
        .required('Email is required'),
    password: Yup.string()
        .required('Password is required')
        .min(6, 'The password must contain between 6 and 60 characters.'),
});


const commonPasswordSchema = ({
    password: Yup.string()
        .required('Password is required')
        .min(6, 'The password must contain between 6 and 60 characters.'),
    confirmPassword: Yup.string()
        .required('Confirm password is required')
        .test('passwords-match', 'Passwords must match', function (value) {
            return this.parent.password === value;
        }),
})
export const resetPasswordVale = { password: '', confirmPassword: '' }
export const resetPasswordDefaultSchema = Yup.object().shape({
    email: Yup.string()
        .required('Email is required')
        .email('Please provide a valid email address.')
        .matches(/^(?!.*\.{2,})(?=.*@)[^@]+(?=.*\.[^.]+$).*/, 'Invalid email address'),
    ...commonPasswordSchema
});

export const forgotPasswordValues = { key: '', password: '', confirmPassword: '' }
export const forgotPasswordDefaultSchema = Yup.object().shape({
    key: Yup.string().required('Temporary key is required'),
    ...commonPasswordSchema
});

export const ChangeMyAccountPasswordSchema = Yup.object().shape({
    currentpassword: Yup.string().trim().required('Please enter current password'),
    ...commonPasswordSchema
});

export const signUpValidationSchema = (activestep, isUserLogin, isWebAlias = false, section = "") => {
    const validationArray = [
        Yup.object().shape({
            email: Yup.string()
                .email('Invalid email address')
                .matches(/^(?!.*\.{2,})(?=.*@)[^@]+(?=.*\.[^.]+$).*/, 'Invalid email address')
                .required('Email is required'),
            firstName: Yup.string().required('First Name is required'),
            lastName: Yup.string().required('Last Name is required'),
            // shipping_country: Yup.string().required('Please select your country.'),
            // shipping_state: Yup.string().required('Please select your state.'),
            phone: Yup.string()
                .required('Phone number is required').min(7, "Invalid phone number").max(20, "Invalid phone number").matches(/^\d+$/, "Only numbers without spaces are allowed."),

            password: isUserLogin ? Yup.string().notRequired() : Yup.string().required('Password is required.').matches(/^(?=.*[A-Z])(?=.*\d)[A-Za-z\d!@#$%^&*()_\-+=<>?:"{}|~`'[\]\\;,.\/]{6,}$/, 'Password must contain an uppercase, a number and minimum of six characters'),
            // confirm_password: isUserLogin ? Yup.string().notRequired() : Yup.string().required('Confirm password is required.').test('confirm_password', 'Password and confirm password should be same', function (val) {
            //     const password = this.resolve(Yup.ref('password'));
            //     if (val !== password) return false;
            //     return true;
            // }),
            city: Yup.string().required('City is required'),
            zipcode: Yup.string().required('Zip code is required'),
            address: Yup.string().required('Address is required'),
            address_2: Yup.string().notRequired(),

            webAlias: Yup.string()
                .matches(/^[a-zA-Z0-9]+$/, 'Web Alias should not contain special characters')
                .required('Web Alias is required'),

            shirtsize: Yup.string().required('Shirt Size is required'),

            termscondition: Yup.bool().oneOf([true], 'Please accept the terms and conditions'),
            promotions: Yup.bool().notRequired(),
            policyProcedures: Yup.bool().oneOf([true], 'Please accept the Policies & Procedures'),
        })
    ];
    return validationArray[activestep];
};







